import { Component, OnInit } from '@angular/core';
import { StoreService } from '../../core';
import { Router } from '@angular/router';
import { DownloadService } from '../../download/download.service';
import { BaseCursus } from '../base-cursus';
import { Cycle, SessionItem, eItem, WSRegMode } from '../../shared';
import { PathMode } from '../../shared/path.model';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'webstore-cyclefile',
  templateUrl: './cyclefile.component.html',
  styleUrls: ['./cyclefile.component.css']
})

export class CyclefileComponent extends BaseCursus implements OnInit {
  hasResponsable: boolean = false;
  cycledata: Cycle;                     // cycle data from json cache

  constructor(
    public store: StoreService,
    private router: Router,
    private donwlfile: DownloadService,
  ) {
    super(store);
  }

  ngOnInit(): void {
    this.store.showSplash(true);
    this.store.AppSettings.RegistrationMode = WSRegMode.PREINSCRIPTION_CYCLE
    //this.store.begin.typeInscription = 'PREINSCRIPTIONCYCLE';

    const parentCycle: SessionItem | null = super.getSession(eItem.CYCLE);
    this.cycledata = parentCycle && parentCycle.jsData && parentCycle.jsData !== ''
      ? JSON.parse(parentCycle.jsData)
      : new Cycle;
    this.hasResponsable = this.store.PathItem.hasResponsable(PathMode.CYCLE, this.cycledata.Ident);

    this.store.showSplash(false);
  }

  selectCycle(): void {
    this.router.navigateByUrl(this.store.begin.access === 'MIXED'
      ? this.store.AppRoutes.FORMMIXED
      : this.store.AppRoutes.FORMEXTRANET);
  }

  downloadDoc(idDoc: string): void {
    this.donwlfile.downloadFile(idDoc);
  }
}
